<template>
  <div>
    <div class="footer">
      <span class="span">
        Copyright ©成都乐见数字科技有限公司,
        All Rights Reserved.
      </span>
      <a class="beian" href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">备案号：蜀ICP备2025127465号-1</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "footer",
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped lang='less'>
@Font: 48;
.footer {
  height: 68px;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #FFFFFF;
  background-color:rgba(17, 17, 17, 0.7)
}
.beian {
  color: #FFFFFF;
  text-decoration: none;
  margin-left: 12px;
  font-size: 12px;
  &:hover {
    text-decoration: underline;
  }
}

@media screen and (max-width: 750px) {
  .footer {
    height: auto;
    padding: 20rem / @Font 0;
    text-align: center;
    font-size: 24rem / @Font;
    flex-direction: column;
  }
  .span {
    width: auto;
    height: auto;
    line-height: 1.5;
  }
  .beian {
    margin-left: 0;
    margin-top: 10rem / @Font;
  }
}
</style>
